const detailButtonClassName =
  'inline-flex items-center gap-2 px-10 py-3.5 bg-[#89B56B] text-white font-medium rounded-full hover:bg-[#5DAA68] transition-colors duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-[#89B56B]/20';

const AiDevelopment = () => {
  return (
    <section id="ai-development" className="py-16 bg-[#F8FAF6]">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,38%)_minmax(0,62%)] gap-10 lg:gap-8 lg:items-center">
          {/* タイトル：スマホ1番目 / PC右上 */}
          <div className="max-w-[36rem] lg:max-w-none mx-auto lg:mx-0 w-full lg:col-start-2 lg:row-start-1 text-left">
            <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter'] text-center lg:text-left">
              Next Generation Development
            </p>
            <h2 className="text-lg md:text-xl lg:text-[1.5rem] xl:text-[1.75rem] font-bold text-[#89B56B] mb-0 lg:mb-6 leading-snug font-['Noto_Sans_JP']">
              <span className="block xl:whitespace-nowrap">ビジネスを穿つ「最強の矛（AI）」に、</span>
              <span className="block xl:whitespace-nowrap">すべてを護り抜く「イージスの盾（セキュリティ）」を。</span>
            </h2>
          </div>

          {/* 画像：スマホ2番目 / PC左 */}
          <div className="w-full lg:col-start-1 lg:row-start-1 lg:row-span-2 flex justify-center lg:justify-start">
            <div
              className="relative overflow-hidden w-full max-w-[360px] lg:max-w-full aspect-[24/17]"
              style={{
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #3AAFA9 0%, #5DAA68 50%, #89B56B 100%)',
              }}
            >
              <img
                src="/image/businessServices3.jpg"
                alt="AI活用開発"
                title="AI活用開発 - 株式会社MSK"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-[#3AAFA9]/15" />
            </div>
          </div>

          {/* 本文＋ボタン：スマホ3番目 / PC右下 */}
          <div className="max-w-[36rem] lg:max-w-none mx-auto lg:mx-0 w-full lg:col-start-2 lg:row-start-2 text-left">
            <div className="space-y-4 text-sm text-gray-600 leading-[2]">
              <p>
                激変するAI時代、企業が手にするべきは、圧倒的なスピードを生む「攻めの技術」と、
                <br className="hidden xl:block" />
                情報漏洩を絶対に許さない「守りの思想」の融合です。
              </p>
              <p>
                株式会社MSKは、RAGをはじめとする最先端のAIシステム開発（最強の矛）を行いながら、
                <br className="hidden xl:block" />
                ハッカー視点でのペンテストとAIによる24時間監視（イージスの盾）を標準網羅。
              </p>
              <p>
                すでに自社基盤で100%実稼働している信頼のノウハウで、貴社のDXを安全に、そして劇的に加速させます。
              </p>
            </div>
            <div className="mt-8 text-center lg:text-left">
              <a
                href="https://lp.msk2.co.jp/next-ai-build/"
                target="_blank"
                rel="noopener noreferrer"
                className={detailButtonClassName}
              >
                サービス詳細を見る
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiDevelopment;
